import { render, staticRenderFns } from "./reviseRecordDetail.vue?vue&type=template&id=454793cc&"
import script from "./reviseRecordDetail.vue?vue&type=script&lang=js&"
export * from "./reviseRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./reviseRecordDetail.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports